import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-align-right-icon',
  templateUrl: './text-align-right.component.html'
})
export class TextAlignRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
